<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: `Usuarios del APP (${users.length})`,
        }
      ]"/>

    <div class="card ml-15">
      <div class="card-body">

        <div class="row">
          <div class="col-sm-6 text-left">
            <button @click="copyEmails" class="btn main-bg">Copiar {{ $helpers.asNumber(usersWithEmailCount) }} correos</button>
          </div>
          <div class="col-sm-6 text-right">
            <button :disabled="users.length === 0" class="btn main-bg" @click="exportToExcel()">Exportar</button>
          </div>
        </div>

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table table-condensed table-sm" id="users-table">
            <thead class="thead-light">
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Teléfono</th>
                <th>Registro</th>
                <th>Version</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="item in users" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.appVersion || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import {UserService} from '../../services/UserService';

export default {
  name: 'Users',
  components: { BreadCrumbs,Loader },
  data:function(){
    return {
      users: [],
      loading: false,
      toCopy: '',
      userService: new UserService()
    }
  },
  methods: {
    exportToExcel() {
      const data = [];
      this.users.forEach((o) => {
        data.push([
          o.name,
          o.email || '',
          o.phone || '',
          o.date || '',
          o.appVersion || '',
        ]);
      });

      data.unshift([
        "Nombre",
        "Correo",
        "Teléfono",
        "Fecha registro",
        "Version APP",
      ]);
      this.$helpers.exportToCsv("Usuarios App Domicanasta.csv", data);
    },
    copyEmails(){
      const tempInput = document.createElement('input');
      tempInput.value = this.users.map(x => x.email).join(',');
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.$helpers.toast(`Se copiaron ${this.$helpers.asNumber(this.users.length)} correos al porta papeles`);
    },
    async getUsers(){
      this.loading = true;
      const res = await this.userService.getAppUsers();
      if(res.ok){
        this.users = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
  },
  beforeMount: async function() {
    await this.getUsers();
    
    this.$nextTick(function(){
      jQuery(function(){
        $('#users-table').DataTable({
          scrollY:        '45vh',
          scrollCollapse: true,
        });
      });      
    });

  },
  computed: {
    usersWithEmailCount(){
      return this.users.filter(x => x.email).length;
    }
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 400;
} 
</style>